import { _ } from "js/vendor";
import { presentations as presentationsApi } from "apis/callables";
import type { IPresentation } from "common/interfaces";
import db from "js/db";

import ApiAdapter from "./apiAdapter";

class PresentationsAdapter extends ApiAdapter<IPresentation, {}> {
    protected get _preloadedInitializationAllowed() {
        return true;
    }

    async _createApi(model: IPresentation): Promise<IPresentation> {
        throw new Error("Not supported, use createPresentationWithSlidesAndResource instead");
    }

    async _updateApi(
        changesetUpdates: Partial<IPresentation>, changesetOriginal: Partial<IPresentation>
    ): Promise<Partial<IPresentation>> {
        const { modifiedAt, _changeId } = await presentationsApi.updatePresentation({
            id: this.id,
            changesetOriginal,
            changesetUpdates,
            _changeId: this.model.attributes._changeId,
        });
        return { modifiedAt, _changeId };
    }

    async _getApi(): Promise<IPresentation> {
        return await presentationsApi.getPresentation({
            id: this.id,
        });
    }

    _composeModel(baseModel: Partial<IPresentation>): IPresentation {
        return { ...baseModel, id: this.id } as IPresentation;
    }

    _getPusherChannelId(): string {
        return `private-presentation-${this.id}`;
    }

    createUid() {
        return db().push().key as string;
    }
}

export default PresentationsAdapter;
